<template>
  <div class="modal">
    <!-- <div class="modal__bg" @click="$emit('close')"></div> -->
    <button class="modal__close" @click="$emit('close')">x</button>
    <div class="modal__container">
      <slot name="body"></slot>
    </div>
  </div>
</template>
